import React from "react";
import { getStageMessage } from "./getStageMessage";
import "./meetingdetails.css";
import GetImage from "../../components/getimage/Getimage";
import getMeetingTime from "./utility/getMeetingTime";
import { getDateLabel } from "./utility/getDateLabel";
const Detailssection = ({ details, userID,meetingInfo }) => {
console.log(meetingInfo,"meetingInfo")
  if (!details?.length) return null;


const groupedData = details.reduce((acc, item) => {
  const label = getDateLabel(item.logtime);

  if (!acc[label]) {
    acc[label] = [];
  }

  acc[label].push(item);
  return acc;
}, {});
  return (
    <div style={{height:"75vh" , overflowY:"auto" , paddingBottom:"10vh"}}>
    <div style={{marginTop:"20px"}}>
  {Object.keys(groupedData).map((dateLabel) => (
    <div key={dateLabel}>

     
      <div  style={{display:"flex", justifyContent:"center" , marginRight:"70px"}}>
        <p className="date-header" >
        {dateLabel}
            </p>
      </div>

     
      {groupedData[dateLabel].map((item, index) => {

        const stageData = getStageMessage({
          actionType: item?.actiontype,
          actionByEmpID: item?.actionbyempid,
          actionByEmpName: item?.actionbyempname,
          createdByEmpID: meetingInfo?.createdbyempid,
          createdByEmpName: meetingInfo?.createdbyempname,
          hostedByEmpID: meetingInfo?.hostempid,
          hostedByEmpName: meetingInfo?.hostempname,
          userID,
          data: item?.data,
          details:meetingInfo
        });

        return (
          <div key={index} className="detailsitem">

            <div className="image-row" style={{display:"flex", justifyContent:"center" , marginRight:"70px"}}>
              {stageData.leftImage && (
                <GetImage
                  imgID={stageData.leftImage}
                  width="40px"
                  height="40px"
                />
              )}

              {stageData.showRight &&
                stageData.rightImage &&
                stageData.rightImage != stageData.leftImage && (
                  <GetImage
                    imgID={stageData.rightImage}
                    width="40px"
                    height="40px"
                  />
                )}
            </div>

<div
  style={{
    display: "flex",
    alignItems: "center",
    width: "100%",
  }}
>
  
  <div
   
  style={{
    flex: 1,
    borderTop: "1px solid #ff4d4f",
    marginRight: "10px",
  }}

  ></div>

  
  <div
    style={{
      color: "red",
      fontWeight: "500",
      textAlign: "center",
      whiteSpace: "nowrap",
    }}
    dangerouslySetInnerHTML={{ __html: stageData.message }}
  />

  <div
  style={{
    flex: 1,
    borderTop: "1px solid #ff4d4f",
    marginRight: "10px",
  }}
  ></div>

  
  <div
    style={{
      marginLeft: "15px",
      whiteSpace: "nowrap",
      color: "gray",
      fontSize: "12px",
    }}
  >
    {getMeetingTime(item.logtime.date)}
  </div>
</div>
           <div dangerouslySetInnerHTML={{__html:item.data}}>
    
</div>

          </div>
        );
      })}
    </div>
  ))}
</div>


    </div>
  );
};

export default Detailssection;